module.exports = __webpack_public_path__ + "static/aws-050c49b44a5757e9b3d8b3c391eef099.svg";